<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <div class="title-box">
            <el-image :src="cheImage" class="title-label"></el-image
            >公司基础信息
          </div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item prop="companyName" label="公司名称">
                <el-input
                  v-model="form.companyName"
                  clearable
                  autocomplete="off"
                  maxlength="50"
                  placeholder="请输入"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="companyType" label="公司类型">
                <el-select
                  style="width: 100%"
                  v-model="form.companyType"
                  filterable
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in $dict.companyType2Options"
                    :key="item.dictCode"
                    :label="item.dictLabel"
                    :value="item.dictCode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="city" label="公司地址" required>
                <el-cascader
                  style="width: 100%"
                  ref="cascader"
                  v-model="form.city"
                  @change="handleChange"
                  :props="cityProps"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="margin-top: 0.32rem">
              <el-form-item prop="address">
                <el-input
                  v-model="form.address"
                  clearable
                  autocomplete="off"
                  maxlength="30"
                  placeholder="请输入详细地址"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <div class="title-box">
            <el-image :src="cheImage" class="title-label"></el-image
            >超管账户信息
          </div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item prop="adminUsername" label="公司联系人">
                <el-input
                  v-model="form.adminUsername"
                  clearable
                  autocomplete="off"
                  maxlength="30"
                  placeholder="请输入"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="adminPhone" label="手机号码">
                <el-input
                  v-model="form.adminPhone"
                  clearable
                  autocomplete="off"
                  @change="handleChangePhone"
                  maxlength="11"
                  placeholder="请输入"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                prop="adminAccount"
                label="超管账号（平台登录账号）"
              >
                <el-input
                  style="width: 50%"
                  v-model="form.adminAccount"
                  clearable
                  autocomplete="off"
                  placeholder="请输入"
                />
                <span class="tip">登录密码将通过下发至联系人的手机号码中</span>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="title-box">
            <el-image :src="cheImage" class="title-label"></el-image
            >公司司机入驻上线费收取规则
          </div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item prop="vehicleOnlineFee" label="车辆上线费用">
                <el-input
                  v-model="form.vehicleOnlineFee"
                  clearable
                  autocomplete="off"
                  maxlength="50"
                  placeholder="请输入"
                >
                  <div slot="append">元</div>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="gpsFee" label="GPS安装费">
                <el-input
                  v-model="form.gpsFee"
                  clearable
                  autocomplete="off"
                  maxlength="50"
                  placeholder="请输入"
                >
                  <div slot="append">元</div>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="premium" label="保险费">
                <el-input
                  v-model="form.premium"
                  clearable
                  autocomplete="off"
                  maxlength="50"
                  placeholder="请输入"
                >
                  <div slot="append">元</div>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="driverManageFee" label="司机管理费">
                <el-input
                  v-model="form.driverManageFee"
                  clearable
                  autocomplete="off"
                  maxlength="50"
                  placeholder="请输入"
                >
                  <div slot="append">元</div>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import { addInfo, editInfo, detailInfo } from "./api";
import { validatePhone, validatePrice } from "@/utils/validate";
import { getAreaNext } from "@/views/commonApi";
export default {
  name: "AddOrEdit",
  components: {
    DialogContainer,
  },
  data() {
    return {
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "40%",
        show: false,
        title: "二级公司创建",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      cheImage: require("@/assets/imgs/title.png"),
      cityProps: {
        lazy: true,
        checkStrictly: true, //可选择任意节点
        lazyLoad(node, resolve) {
          // setTimeout(() => {
          const nodes = [];
          let query = {};
          // 构造查询条件
          if (node.value) {
            query = {
              code: node.value,
            };
          }
          //查询接口
          getAreaNext(query).then((res) => {
            res.data.map((item) => {
              let obj = {
                value: item.areaCode,
                label: item.areaName,
                leaf: item.areaLevel === 2,
                disabled: item.areaLevel <= 0,
              };
              nodes.push(obj);
            });
            //重新加载节点
            resolve(nodes);
          });
          // }, 500);
        },
      },
      form: {
        address: "",
        adminAccount: "",
        adminPhone: "",
        adminUsername: "",
        companyName: "",
        companyType: "",
        cityCode: "",
        cityName: "",
        districtCode: "",
        districtName: "",
        provinceCode: "",
        provinceName: "",
        premium: "",
        vehicleOnlineFee: "",
        driverManageFee: "",
        gpsFee: "",
        city: [],
      },
      rules: {
        price: [
          { required: true, message: "不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ],
        gpsFee: [
          { required: true, message: "不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ],
        driverManageFee: [
          { required: true, message: "不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ],
        vehicleOnlineFee: [
          { required: true, message: "不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ],
        premium: [
          { required: true, message: "不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ],
        companyType: [{ required: true, message: "公司类型不能为空" }],
        adminPhone: [
          { required: true, message: "手机号码不能为空" },
          { validator: validatePhone, trigger: "blur" },
        ],
        adminUsername: [{ required: true, message: "公司联系人不能为空" }],
        adminAccount: [{ required: true, message: "超管账号不能为空" }],
        address: [{ required: true, message: "公司地址不能为空" }],
        companyName: [{ required: true, message: "公司名称不能为空" }],
        city: [{ required: true, message: "省市不能为空" }],
      },
    };
  },
  mounted() {},
  methods: {
    handleChange() {
      this.form.provinceCode = "";
      this.form.provinceName = "";
      this.form.cityCode = "";
      this.form.cityName = "";
      this.form.districtCode = "";
      this.form.districtName = "";
      const nodes = this.$refs.cascader.getCheckedNodes();
      nodes[0].pathNodes.forEach((node) => {
        if (node.level === 1) {
          this.form.provinceCode = node.value;
          this.form.provinceName = node.label;
        } else if (node.level === 2) {
          this.form.cityCode = node.value;
          this.form.cityName = node.label;
        } else if (node.level === 3) {
          this.form.districtCode = node.value;
          this.form.districtName = node.label;
        }
      });
    },
    init(row) {
      if (!!row) {
        this.getDetail(row.companyId);
      }
      this.dialogObj.show = true;
    },
    handleChangePhone() {
      if (!this.form.adminAccount) {
        this.form.adminAccount = this.form.adminPhone;
      }
    },
    setCity(data) {
      let arr = [];
      if (data.districtCode) {
        arr = [data.provinceCode, data.cityCode, data.districtCode];
      } else {
        arr = [data.provinceCode, data.cityCode];
      }
      return arr;
    },
    getDetail(companyId) {
      detailInfo(companyId).then((res) => {
        if (res.code === 200) {
          res.data.city = this.setCity(res.data);
          this.form = res.data;
        }
      });
    },
    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          let methodName = "";
          if (this.form.companyId) {
            methodName = editInfo;
          } else {
            methodName = addInfo;
          }
          const par = {
            companyId: this.form.companyId,
            address: this.form.address,
            adminAccount: this.form.adminAccount,
            adminPhone: this.form.adminPhone,
            adminUsername: this.form.adminUsername,
            companyName: this.form.companyName,
            companyType: this.form.companyType,
            provinceCode: this.form.provinceCode,
            provinceName: this.form.provinceName,
            cityCode: this.form.cityCode,
            cityName: this.form.cityName,
            districtCode: this.form.districtCode,
            districtName: this.form.districtName,
            premium: this.form.premium,
            vehicleOnlineFee: this.form.vehicleOnlineFee,
            driverManageFee: this.form.driverManageFee,
            gpsFee: this.form.gpsFee,
          };
          methodName(par)
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success(
                  this.form.companyId ? "编辑成功" : "保存成功"
                );
                this.$parent.handleAddOrEditSuccess(
                  this.form.companyId ? "edit" : "add"
                );
                this.dialogObj.beforeClose();
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .left-box {
    padding-right: 0.5rem;
    padding-bottom: 0.1rem;
    position: relative;
    display: flex;
    align-items: center;
    .left-box-top {
      display: flex;
      align-items: center;
      .label {
        width: 0.2rem;
        height: 0.2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0.02rem;
        font-size: 0.12rem;
      }
      .zhuang {
        color: #5cc41a;
        background-color: rgba(92, 196, 26, 0.3);
      }
      .xie {
        color: #e52019;
        background-color: rgba(229, 32, 25, 0.3);
      }
      .name {
        color: #000000;
        font-size: 0.18rem;
        line-height: 0.2rem;
        padding-left: 0.04rem;
      }
    }
    .date {
      color: #8c8c8c;
      font-size: 0.12rem;
      line-height: 0.2rem;
    }
  }
  .left-box:nth-last-of-type(1)::before {
    display: none;
  }
  .car-img {
    width: 0.1rem;
    height: 0.1rem;
    margin-right: 0.04rem;
  }
  .center-box-2 {
    display: flex;
    align-items: center;
    line-height: 0.24rem;
    color: #000000;
    font-size: 0.12rem;
    position: relative;
  }
  .center-box-2 {
    padding-left: 0.2rem;
    position: relative;
    &::before {
      content: "";
      width: 0.01rem;
      height: 0.1rem;
      background-color: #dce5f5;
      position: absolute;
      left: 0.1rem;
    }
  }
  .center-box-1 {
    color: #1269ff;
  }
  .title-box {
    padding: 0rem 0 0.1rem;
    .title-label {
      width: 0.08rem;
      height: 0.08rem;
      margin-right: 0.06rem;
    }
  }
  .tip {
    font-size: 0.12rem;
    padding-left: 0.1rem;
    color: #999999;
  }
}
</style>
